import { Plus, Shield } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface CoverageEmptyStateProps {
  onCreateCoverage: () => void;
  locked?: boolean;
}

export const CoverageEmptyState = ({
  onCreateCoverage,
  locked = false,
}: CoverageEmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="bg-gray-100 rounded-full p-4 mb-4">
        <Shield className="h-8 w-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        No coverage information yet
      </h3>
      <p className="text-sm text-gray-500 text-center max-w-sm mb-6">
        Start tracking insurance policies by adding coverage information for
        this matter.
      </p>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <Button
              onClick={onCreateCoverage}
              className="gap-2"
              disabled={locked}
            >
              <Plus className="h-4 w-4" />
              Add First Coverage
            </Button>
          </span>
        </TooltipTrigger>
        {locked && (
          <TooltipContent>
            Coverage creation is locked. Unlock to add new coverage.
          </TooltipContent>
        )}
      </Tooltip>
    </div>
  );
};
